module.exports = __webpack_public_path__ + "img/bg.cba4a82a.png";